import React from 'react';

import { Container } from './styles';

interface ISpeechBubbleProps {
  message: string;
}

const SpeechBubble: React.FC<ISpeechBubbleProps> = ({ message }) => (
  <Container>
    <p>{`"${message}"`}</p>
  </Container>
);

export default SpeechBubble;
